import {ChannelReferralPageModel} from './model';
import {action} from 'mobx';
import {RedirectFunction, RouterState} from 'react-router';
import {stripQueryString} from '../../../lib/string';
import {LICKD_YOUTUBE_CHANNEL_ID} from '../../../constants';
import {BugsnagController} from '../../bugsnag/controller';
import {PrismicController} from '../../prismic/controller';
import {EnvModel} from '../../env/model';
import {UIController} from '../../ui/controller';
import {ImageController} from '../../image/controller';

export class ChannelReferralPageController {

  constructor(
    private model: ChannelReferralPageModel,
    private prismic: PrismicController,
    private bugsnag: BugsnagController,
    private env: EnvModel,
    private ui: UIController,
    private image: ImageController,
  ) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    const slug = stripQueryString(nextState.params['channel']) || LICKD_YOUTUBE_CHANNEL_ID;
    this.model.channel = slug;

    this.model.loading = true;

    const document = 'channel_referral';

    await this.ui.setSEO(nextState.location.pathname);

    try {
      const [{ data }] = await Promise.all([
        this.prismic.getSingle(document),
        this.env.ready
      ]);

      const image = this.image.preloadContent(data.document_image.url, {width: 1200});

      this.ui.setTitle(data.document_title);
      this.ui.setDescription(data.document_description);
      this.ui.setOpenGraph({image});
      this.ui.setBreadcrumbs([{
        path: '/r' + (this.model.channel ? '/' + slug : ''),
        label: 'You’ve been Lickd!'
      }]);

      // Key text (simple string)
      this.model.document_title_match = data.document_title_match;
      this.model.document_title_missing = data.document_title_missing;
      this.model.document_description = data.document_description;
      this.model.header_missing = data.header_missing;
      this.model.referral_text = data.referral_text;
      this.model.sub_header = data.sub_header;
      this.model.cta_invite_copy = data.cta_invite_copy;
      this.model.cta_missing_copy = data.cta_missing_copy;
      this.model.cta_landing_button = data.cta_landing_button;
      this.model.cta_complete_button = data.cta_complete_button;
      this.model.cta_complete_url = data.cta_complete_url;
      this.model.modal_hero_pre = data.modal_hero_pre;
      this.model.modal_hero_post = data.modal_hero_post;
      this.model.modal_title = data.modal_title;
      this.model.modal_caveat = data.modal_caveat;

      // RichText (html)
      this.model.modal_copy_match = data.modal_copy_match;
      this.model.modal_copy_missing = data.modal_copy_missing;

      // Image
      this.model.document_image = data.document_image.url;
      this.model.background_image = data.background_image.url;

    } catch (e) {
      this.bugsnag.notifyException(e);
    } finally {
      this.model.loading = false;
    }

    return;
  };
}